<template>
  <div class="iy-wrap">
    <div class="iy-aside">
      <div class="iy-logo">申请管理平台</div>
      <div class="iy-aside-hide">
        <div class="iy-menu">
          <div class="iy-menu-item">
            <router-link to="/apply">
              <span>应届申请管理</span>
            </router-link>
          </div>
          <div class="iy-menu-item" v-if="role!==3">
            <router-link to="/previous">
              <span>往届申请管理</span>
            </router-link>
          </div>
          <div class="iy-menu-item" v-if="role!==3">
            <router-link to="/times">
              <span>多次申请管理</span>
            </router-link>
          </div>
          <div class="iy-menu-item" v-if="role!==3">
            <router-link to="/role">
              <span>管理员管理</span>
            </router-link>
          </div>
          <div class="iy-menu-item" v-if="role!==3">
            <router-link to="/param">
              <span>参数管理</span>
            </router-link>
          </div>
          <div class="iy-menu-item">
            <router-link to="/school">
              <span>学校管理</span>
            </router-link>
          </div>
          <div class="iy-menu-item" v-if="role!=3">
            <router-link to="/notice">
              <span>通知管理</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="iy-article">
      <div class="iy-header">
        <div class="iy-user">
          <el-avatar icon="el-icon-user-solid" size="medium"></el-avatar>
          <el-dropdown>
            <span class="iy-user-name">{{userInfo.userName}}<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="editPassword=true">修改密码</el-dropdown-item>
              <el-dropdown-item divided @click.native="toLogout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="iy-body">
        <router-view/>
      </div>
    </div>
    <editPassword :dialogShow="editPassword" @close="editPassword=false" @success="_updatePassword"></editPassword>
  </div>
</template>

<script type="text/ecmascript-6">
  import {mapState, mapMutations, mapActions} from 'vuex'

  const editPassword = () => import('@/dialog/updatePassword')
  export default {
    data () {
      return {
        editPassword: false
      }
    },
    computed: {
      ...mapState({
        userInfo: state => state.base.userInfo,
        role: state => state.base.userInfo.role
      })
    },
    created () {
      if (this.role === 1 || this.role === 2) {
        this.getSchool()
      }
      this.getProvince()
      this.getUploadInfo()
    },
    methods: {
      ...mapMutations(['removeToken']),
      ...mapActions(['getSchool', 'getProvince', 'getUploadInfo']),
      toLogout () {
        this.$api.logout(() => {
          this.removeToken()
          this.$router.replace({path: '/assist/login'})
        })
      },
      _updatePassword () {
        this.editPassword = false
        this.toLogout()
      }
    },
    components: {
      editPassword
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>
  $--aside-width: 200px;
  $--header-height: 50px;
  $--theme-color: #4292ff;
  .iy-wrap {
    height: 100%;
    min-height: 600px;
    min-width: 720px;
    position: relative;
    z-index: 5;
    overflow: hidden;
  }

  .iy-aside {
    width: $--aside-width;
    position: absolute;
    left: 0;
    top: 0;
    transition: all .3s;
    z-index: 1001;
    height: 100%;
    background: #545c64;
    box-sizing: border-box;
    padding-top: $--header-height + 110px;

    &-hide {
      overflow: hidden;
      height: 100%;
    }
  }

  .iy-menu {
    width: $--aside-width;
    padding-right: 20px;
    overflow-x: hidden;
    height: 100%;

    &-item {
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      cursor: pointer;

      a {
        display: block;
        padding: 0 45px;
        color: #fff;

        &.active {
          color: $--theme-color;
          background: #474747;
        }
      }
    }
  }

  .iy-logo {
    height: $--header-height;
    line-height: $--header-height;
    background-color: $--theme-color;
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: 20px;
    background-image: url(/static/img/logo.png);
    background-repeat: no-repeat;
    background-position: center 20px;
    background-size: 90px auto;
    padding-top: 110px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  .iy-article {
    box-sizing: border-box;
    padding-top: $--header-height;
    height: 100%;
    position: absolute;
    left: $--aside-width;
    right: 0;
    overflow: hidden;
    z-index: 8888;
    transition: all .3s;
    width: auto;
  }

  .iy-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: #fff;
    box-shadow: 0 0 8px #cac6c6;
  }

  .iy-user {
    float: right;
    padding: 8px 10px;

    .el-avatar {
      vertical-align: middle;
    }

    .el-dropdown {
      vertical-align: middle;
    }

    .iy-user-name {
      line-height: 36px;
      outline: none;
      cursor: pointer;
      margin-left: 10px;
    }
  }

  .iy-body {
    padding: 8px;
    box-sizing: border-box;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/index.vue